import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import HeroCapabilityIcon from './HeroCapabilityIcon';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const strip = t.hero.capabilityStrip;

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) {
      const offset = 58;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-region">
      <header
        id="hero"
        className="hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL || ''}/images/bg.jpg)`,
        }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-description">
          <h1>{t.hero.title}</h1>
          <p>{t.hero.description}</p>
          <button type="button" className="hero-cta" onClick={scrollToContact}>
            {t.hero.ctaContact}
          </button>
        </div>
      </header>
      <section
        className="hero-capability-strip"
        aria-label={strip.ariaLabel}
      >
        <div className="hero-capability-strip-inner">
          <ul className="hero-capability-list">
            {strip.items.map((item) => (
              <li key={item.id} className="hero-capability-item">
                <div className="hero-capability-icon-wrap">
                  <HeroCapabilityIcon id={item.id} />
                </div>
                <div className="hero-capability-text">
                  <span className="hero-capability-title">{item.title}</span>
                  <span className="hero-capability-line">{item.line}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Hero;

